import { IIdentity, ITableData } from './common';
import { TRiskLevel } from './riskLevels';

export enum TSupplementResponseStatus {
  None = 1,
  NeedsInfo,
  New,
  Pending,
  Complete,
}

export enum TAdminResponseType {
  NeedsInfo = 1,
  Medication,
}

export interface IDietarySupplementTableData extends IIdentity {
  isMedication: boolean;
}

export type IDietarySupplementSearchResult = ITableData<IDietarySupplementTableData>;

export interface IDietarySupplementDetails extends IIdentity {
  adminResponseType: TAdminResponseType | null;
  comments: string | null;
  companyName: string | null;
  productLink: string | null;
  supplementCategoryId: number | null;
}

export interface ISupplementInquiry {
  supplementId: number | null;
  supplementInquiryId: number;
  submittedOn: string;
  respondedOn: string;
  name: string;
  needsAdminResponse: boolean;
  supplementInquiryStatusId: TSupplementResponseStatus;
  userEnteredSupplementId?: number | null;
  isActive: boolean;
}

export interface ISupplementResponse {
  supplementInquiryId: number;
  name: string;
  riskLevelId: TRiskLevel | null;
  supplementInquiryStatusId: TSupplementResponseStatus;
  isActive: boolean;
}

export interface ISupplementResponseDetails extends IIdentity {
  supplementCompanyName: string;
  supplementCategoryId: number;
  riskLevelId: TRiskLevel | null;
  productLink: string;
  supplementInquiryStatusId: TSupplementResponseStatus;
  drugClassNames: string[] | null;
  ingredientNames: string[] | null;
  comments: string;
  userEnteredSupplementId?: number;
  isActive: boolean;
}

export interface IUserEnteredSupplementData {
  adminResponseType: TAdminResponseType | null;
  companyName: string | null;
  linkToProductPage: string | null;
  supplementCategoryId?: number | null;
  supplementName: string;
}

export interface IUserEnteredSupplementDataWithComments extends IUserEnteredSupplementData {
  comments: string | null;
}

export interface IUserEnteredSupplement extends IUserEnteredSupplementData {
  id: number;
}

export interface IUserEnteredSupplementAddNote extends IUserEnteredSupplementData {
  note?: string;
}

export interface ISubmitSupplementNeedsInfoFormPayload extends IUserEnteredSupplementAddNote {
  userEnteredSupplementId: number;
}

export type ICreateNewSupplementResponse = IIdentity;

export interface ISearchSupplementsProps {
  search: string;
  page: number;
}
